/**
 * ROTAS69 — category showcase.
 *
 * Every preview pane is server-rendered; pointing at a row only moves one class between
 * already-existing nodes. Nothing is inserted, removed or re-written: in this theme a DOM
 * insertion (a textContent assignment counts) triggers a document-wide :has() invalidation,
 * and `r69cat-current` is deliberately not a name any theme :has() rule matches.
 */
class R69CategoryShowcase extends HTMLElement {
  #rows = [];
  #panes = [];
  #current = 0;

  connectedCallback() {
    this.#rows = Array.from(this.querySelectorAll('[data-r69cat-row]'));
    this.#panes = Array.from(this.querySelectorAll('[data-r69cat-pane]'));
    if (this.#rows.length === 0) return;

    // A phone has no hover and gets the thumbnail layout instead, so only wire the
    // preview where a fine pointer can actually drive it.
    if (window.matchMedia('(hover: hover)').matches) {
      this.#rows.forEach((row, index) => {
        row.addEventListener('pointerenter', () => this.#select(index));
      });
    }

    // Keyboard users tab through the rows; the preview follows the focused one.
    this.addEventListener('focusin', (event) => {
      const row = event.target.closest('[data-r69cat-row]');
      if (row) this.#select(this.#rows.indexOf(row));
    });
  }

  #select(index) {
    if (index === this.#current || index < 0) return;

    this.#rows[this.#current]?.classList.remove('r69cat-current');
    this.#panes[this.#current]?.classList.remove('r69cat-current');
    this.#rows[index]?.classList.add('r69cat-current');
    this.#panes[index]?.classList.add('r69cat-current');

    this.#current = index;
  }
}

if (!customElements.get('r69-category-showcase')) {
  customElements.define('r69-category-showcase', R69CategoryShowcase);
}
